import React, { Component } from 'react'
import AppAlertDiv from '../components/Common/AppAlertDiv'
import { appleStoreUrl, playStoreUrl } from '../lib/utils'

export default class relax extends Component {
    render() {
        return (
            <div>
                <h2>Relax
                </h2>
                <hr className='separator' />
                <br />
                {/* <InsightCards /> */}
                <h3>Meditation Guides and Sleep Stories available on our mobile apps.</h3>
                <AppAlertDiv isHtml={true}
                    message={`<p>Meditation Guides and Sleep Stories are available on our mobile apps (<a href=${appleStoreUrl}
                        target='_blank' rel="noopener noreferrer">iOS</a> and <a href=${playStoreUrl}
                           target='_blank' rel="noopener noreferrer">Android</a>) for now and will be available on web soon.`} showIcon />

            </div>
        )
    }
}
